import { sum } from 'lodash-es';

/**
 * Compute damped value when going from one value to another folowing the rule of criticaly damped system osclilator.
 * from, to - Source and destination value
 * dampingRate - Rate of damping. Lower number (min. 0) means lower damping and slower reaching of the desired value 
 * deltaTime - Simulation step time
 */
export function criticalDampingFromTo(from: number, to: number, dampingRate: number, deltaTime: number): number {
  let delta = to - from;
  delta *= Math.exp(-dampingRate * deltaTime);
  return to - delta;
}

export function clamp(a: number, min: number, max: number) {
  return Math.max(min, Math.min(a, max));
}

/** Round a number to a given precision, precision being defined as a decimal number with a 1 at the least significant place. */
export function roundToPrecision(x: number, precision: number): number {
  x = Math.floor(x / precision + 0.5) * precision;
  if (precision <= 1) {
    x = parseFloat(x.toFixed(-Math.log10(precision))); // this kills numeric precision at last bit in the above
  }
  return x;
}

// Wrap integral number to interval [0, upLimit>
export function wrapIntegerToInterval(num: number, upLimit: number) {
  let temp = num % upLimit;
  if (temp < 0) {
    temp += upLimit;
  }
  return temp;
}

// average a list of numbers, skipping eventual nulls/undefineds
// returns the given default value if there are no valid numbers in the list
export function averageValidNumbers(xs: number[], orDefault: number | undefined): number | undefined {
  if (xs == undefined || xs.length === 0) {
    return orDefault;
  }
  const xsFiltered = xs.filter(x => x != undefined && !isNaN(x));
  const s = sum(xsFiltered);
  const num = xsFiltered.length;
  if (num === 0) {
    return orDefault;
  }
  return s / num;
}

export function leadingZeroes(num: number, length: number): string {
  let numAsString = num.toFixed(0);
  let s = '000000000' + numAsString;
  let allowedLength = Math.max(length, numAsString.length);
  return s.substr(s.length - allowedLength);
}

export function RoundToDecimals(x: number, numPlaces: number) {
  return parseFloat(x.toPrecision(numPlaces));
}

/**
 * Return 0 <= i <= array.length such that !pred(array[i - 1]) && pred(array[i]).
 */
export function binarySearch<type>(array: type[], pred: (type) => boolean) {
  // Originating from: https://stackoverflow.com/questions/22697936/binary-search-in-javascript
  let lo = -1,
    hi = array.length;

  while (1 + lo < hi) {
    const mi = lo + ((hi - lo) >> 1);
    if (pred(array[mi])) {
      hi = mi;
    } else {
      lo = mi;
    }
  }

  return hi;
}
